<template>
	<div class="sidebar-container" :class="{ closeMenu: closeMenu }">
		<div class="logo-container">
			<img
				:src="require('@/assets/images/brand/lema-logo-white.svg')"
				alt="Lema"
				class="brand-logo"
				v-if="!closeMenu"
			/>
			<img
				:src="require('@/assets/images/brand/lema-mark.svg')"
				alt="Lema"
				class="brand-mark"
				v-else
			/>
		</div>

		<div class="menu-item-container" :class="{ mta: closeMenu }">
			<ul class="navigation navigation-main" id="nav" data-menu="menu-navigation">
				<div v-for="menu in menuList" :key="menu.id">
					<li v-if="menu.has_submenu === false" class="nav-item mr-4">
						<router-link
							:to="menu.frontend_route_url"
							class="d-flex"
							:class="{ 'justify-center': closeMenu }"
						>
							<!-- <span class="iconify" data-icon="clarity:dashboard-line"></span> -->
							<img class="iconify" :src="menu.deactive_icon" />
							<span class="menu-title" data-i18n="Dashboard" v-if="!closeMenu">{{
								menu.verbose_name
							}}</span>
						</router-link>
					</li>
					<SiderbarDropdown
						v-else
						class="side-dropdown"
						:title="menu.verbose_name"
						:iconUrl="menu.deactive_icon"
						:mainRoute="menu.frontend_route_url"
					>
						<template slot="navItems" v-if="!closeMenu">
							<li
								v-for="children in menu.children"
								:key="children.id"
								class="nav-item inside submenu mb-0"
							>
								<router-link
									:to="children.frontend_route_url"
									class="nav-link"
									:class="{ 'justify-center': closeMenu }"
								>
									<!-- <span class="iconify" data-icon="bi:plus-square"></span> -->
									<img class="iconify" :src="children.deactive_icon" />
									<span class="menu-title" v-if="!closeMenu">{{ children.verbose_name }}</span>
								</router-link>
							</li>
							<br />
						</template>
					</SiderbarDropdown>
				</div>
			</ul>
		</div>
	</div>
</template>

<script>
import SiderbarDropdown from '../../components/SiderbarDropdown/index.vue';
export default {
	data() {
		return {
			closeMenu: null,
			menuList: [],
		};
	},
	components: {
		SiderbarDropdown,
	},

	created() {
		this.closeMenu = this.$STORE.state.appConfig.closeMenu;
		this.getMenuList();
	},
	watch: {
		'$STORE.state.appConfig': {
			handler() {
				this.closeMenu = this.$STORE.state.appConfig.closeMenu;
			},
			deep: true,
		},
	},
	methods: {
		async getMenuList() {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.MENU_LIST +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId +
					'&is_active=true',
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.menuList = res.data;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
/* ===== Lema sidebar — clean standard admin nav ===== */
.sidebar-container {
	width: 272px;
	height: 100vh;
	display: flex;
	flex-direction: column;
	background: linear-gradient(185deg, #0b1224 0%, #1a2332 100%);
	border-left: 1px solid rgba(255, 255, 255, 0.06);
	box-shadow: 4px 0 26px rgba(3, 6, 12, 0.3);
	transition: width 0.28s cubic-bezier(0.4, 0, 0.2, 1);
	position: relative;
	overflow: hidden;

	&::before {
		content: '';
		position: absolute;
		inset: 0;
		background: radial-gradient(90% 30% at 100% 0%, rgba(58, 166, 166, 0.08), transparent 60%);
		pointer-events: none;
	}

	.logo-container {
		height: 74px;
		flex-shrink: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 0 20px;
		border-bottom: 1px solid rgba(255, 255, 255, 0.06);
		position: relative;
		z-index: 1;

		.brand-logo {
			max-width: 138px;
			height: auto;
			object-fit: contain;
		}
		.brand-mark {
			max-width: 34px;
			height: auto;
		}
	}
}

.closeMenu {
	width: 78px;

	.logo-container {
		padding: 0 12px;
	}
}

/* Section label (was panel-type) */
.panel-type-container {
	flex-shrink: 0;
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 18px 22px 8px;
	position: relative;
	z-index: 1;

	.panel-dot {
		width: 6px;
		height: 6px;
		border-radius: 50%;
		background: var(--lema-cyan);
		box-shadow: 0 0 10px var(--lema-cyan);
	}

	p {
		color: #66748f;
		font-size: 11px;
		font-weight: 700;
		margin: 0;
		letter-spacing: 1.5px;
	}
}

/* Menu container */
.menu-item-container {
	flex: 1;
	min-height: 0;
	overflow: hidden;
	padding: 14px 0;
	position: relative;
	z-index: 1;
}

#nav {
	height: 100%;
	overflow-y: auto;
	overflow-x: hidden;
	padding: 0 12px;

	&::-webkit-scrollbar {
		width: 5px;
	}
	&::-webkit-scrollbar-track {
		background: transparent;
	}
	&::-webkit-scrollbar-thumb {
		background: rgba(255, 255, 255, 0.12);
		border-radius: 3px;
	}
	&::-webkit-scrollbar-thumb:hover {
		background: rgba(58, 166, 166, 0.4);
	}
}

/* Base nav rows (flat, no per-item borders) */
.navigation {
	text-align: right;
	padding: 0;
	margin: 0;
	list-style: none;

	li {
		list-style: none;
		margin: 2px 0 !important;
		display: block;
	}

	a {
		position: relative;
		display: flex;
		align-items: center;
		gap: 12px;
		padding: 10px 14px;
		border-radius: 10px;
		color: #99a7c0;
		font-size: 14px;
		font-weight: 500;
		text-decoration: none;
		transition: background 0.18s ease, color 0.18s ease;

		&:hover {
			background: rgba(255, 255, 255, 0.05);
			color: #e8eefb;

			.iconify {
				opacity: 0.95;
			}
		}

		&.justify-center {
			justify-content: center;
			padding: 10px;
		}
	}

	.menu-title {
		font-size: 14px;
		font-weight: 500;
		margin: 0;
	}
}

/* Neutralize bootstrap mr-4 indent on rows */
.nav-item {
	margin-right: 0 !important;
}

/* Icons */
.iconify {
	width: 20px;
	max-width: 20px;
	height: 20px;
	flex-shrink: 0;
	object-fit: contain;
	transition: opacity 0.18s ease;
	filter: brightness(0) invert(1);
	opacity: 0.6;
}

/* Active row — subtle brand tint + accent bar */
.router-link-active {
	background: linear-gradient(90deg, rgba(58, 166, 166, 0.16) 0%, rgba(45, 139, 139, 0.06) 100%) !important;
	color: #eaf6ff !important;

	&::before {
		content: '';
		position: absolute;
		right: 0;
		top: 50%;
		transform: translateY(-50%);
		width: 3px;
		height: 60%;
		border-radius: 3px 0 0 3px;
		background: linear-gradient(180deg, #3aa6a6, #2d8b8b);
		box-shadow: -2px 0 12px rgba(58, 166, 166, 0.5);
	}

	.iconify {
		opacity: 1 !important;
		filter: brightness(0) invert(1) drop-shadow(0 0 6px rgba(58, 166, 166, 0.7));
	}

	.menu-title,
	span,
	p {
		color: #eaf6ff !important;
		font-weight: 700;
	}
}

/* Submenu rows (indented, with guide line) */
.side-dropdown {
	margin-right: 0;
}

.submenu {
	margin: 0;
	padding: 0;
	background: transparent;
	border: none;
}

.inside {
	position: relative;
	display: block;
	margin: 0;
	padding-right: 30px;

	/* vertical guide line */
	&::before {
		content: '';
		position: absolute;
		right: 20px;
		top: 4px;
		bottom: 8px;
		width: 1.5px;
		background: rgba(255, 255, 255, 0.08);
	}

	a {
		padding: 8px 12px;
		font-size: 13px;
		color: #7f8ea8;

		&:hover {
			background: rgba(255, 255, 255, 0.04);
			color: #dbe4f3;
		}
	}

	.menu-title {
		font-size: 13px !important;
	}

	.iconify {
		width: 17px;
		max-width: 17px;
		height: 17px;
	}

	.router-link-active {
		background: rgba(58, 166, 166, 0.1) !important;
		color: #d7ecff !important;

		&::before {
			height: 55%;
		}
	}
}

/* Responsive */
@media (max-width: 768px) {
	.sidebar-container {
		box-shadow: none;
	}
}

@keyframes slideIn {
	from {
		opacity: 0;
		transform: translateY(-6px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

.nav-item {
	animation: slideIn 0.25s ease forwards;
}

a:focus {
	outline: none;
}
a:focus-visible {
	outline: 2px solid rgba(58, 166, 166, 0.5);
	outline-offset: 1px;
}
</style>
